/** @format */

export function isValidUrl(urlToCheck: string): boolean {
    try {
        const url = new URL(urlToCheck);
        return url.protocol === 'https:';
    } catch {
        return false;
    }
}

export function safeDecodeURIComponent(value: string): string {
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
}
